module.exports = __webpack_public_path__ + "img/Tessellate56.a30411f1.jpg";